import { popupType, showPopup } from '@plugins/biPoint/_configWebstoreV1';
export default {
  data() {
    return {
      visibleCoinsAgreePopup: false
    };
  },
  methods: {
    visibleCoinsAgreePopupHandle(bool) {
      this.visibleCoinsAgreePopup = bool;
      if (bool) {
        showPopup(popupType.aboutBalancePopup);
      }
    }
  }
};
